import { render, staticRenderFns } from "./PagePermission.vue?vue&type=template&id=d3336d3a&scoped=true&"
import script from "./PagePermission.vue?vue&type=script&lang=js&"
export * from "./PagePermission.vue?vue&type=script&lang=js&"
import style0 from "./PagePermission.vue?vue&type=style&index=0&id=d3336d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3336d3a",
  null
  
)

component.options.__file = "PagePermission.vue"
export default component.exports